import { Worksheet } from '../data/worksheetsData';

interface WorksheetCardProps {
  worksheet: Worksheet;
  gradient: string;
  onUnlock: () => void;
}

const difficultyColor = (d: string) => {
  if (d === 'Beginner') return 'bg-green-100 text-green-700';
  if (d === 'Intermediate') return 'bg-amber-100 text-amber-700';
  return 'bg-rose-100 text-rose-700';
};

export default function WorksheetCard({ worksheet, gradient, onUnlock }: WorksheetCardProps) {
  return (
    <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group border border-gray-100">
      {/* Top bar */}
      <div className={`h-2 bg-gradient-to-r ${gradient}`}></div>

      <div className="p-6">
        {/* Header row */}
        <div className="flex items-start justify-between gap-3 mb-3">
          <h3 className="text-base font-bold text-gray-900 leading-snug group-hover:text-teal-700 transition-colors duration-200">
            {worksheet.title}
          </h3>
          {worksheet.free ? (
            <span className="shrink-0 px-3 py-1 bg-teal-100 text-teal-700 text-xs font-bold rounded-full whitespace-nowrap">
              FREE
            </span>
          ) : (
            <span className="shrink-0 px-3 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded-full whitespace-nowrap flex items-center gap-1">
              <i className="ri-lock-line text-xs"></i> Members
            </span>
          )}
        </div>

        <p className="text-sm text-gray-500 leading-relaxed mb-4">{worksheet.description}</p>

        {/* Stats */}
        <div className="flex items-center gap-4 text-xs text-gray-500 mb-5">
          <span className="flex items-center gap-1">
            <i className="ri-file-text-line text-teal-500"></i>
            {worksheet.pages} pages
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-edit-line text-teal-500"></i>
            {worksheet.problems} problems
          </span>
          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${difficultyColor(worksheet.difficulty)}`}>
            {worksheet.difficulty}
          </span>
        </div>

        {/* CTA */}
        {worksheet.free ? (
          <button className={`w-full py-2.5 bg-gradient-to-r ${gradient} text-white text-sm font-semibold rounded-lg hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2`}>
            <i className="ri-download-line"></i>
            Download Free
          </button>
        ) : (
          <button
            onClick={onUnlock}
            className="w-full py-2.5 bg-gray-100 hover:bg-amber-50 border border-gray-200 hover:border-amber-300 text-gray-700 hover:text-amber-700 text-sm font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-lock-line"></i>
            Unlock with Membership
          </button>
        )}
      </div>
    </div>
  );
}
